import Index from './index'
import Historico from './Historico'
import EnvioManual from './EnvioManual'

const route = {
  path: '/mensagens',
  name: 'mensagens',
  component: Index,
  children: [
    { path: 'historico', name: 'mensagens-historico', component: Historico },
    { path: 'envio-manual', name: 'mensagens-envio-manual', component: EnvioManual }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/mensagens/routes.js